'use client';
import dynamic from 'next/dynamic';
const BuyButton = dynamic(() => import('./buy-now-btn'));
const SampleButton = dynamic(() => import('./sample-button'));

export default function NavTitlebar(props) {
  return (
    <div className="w-full justify-center z-10 fixed top-[12%] hidden lg:block">
      <div
        className={`w-[93%] flex mx-auto items-center justify-between p-2 gap-5 bg-white rounded-lg shadow-md shadow-blue-100 ring-1 ring-blue-200 transition-all duration-500 ease-in-out ${
          props.show
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 -translate-y-4 pointer-events-none'
        }`}
      >
        <div className="report-heading flex-1">
          <h2 className="uppercase font-bold">{props.pageTitle}</h2>
        </div>
        <div className="flex px-2 pb-2 justify-center float-end">
          <div className="columns-2 my-auto ms-3 h-10">
            <BuyButton text={props.regionalText('buynow') || 'Buy Now'} />
            <SampleButton
              className="btn btn-download rounded-lg !mt-0"
              text={props.regionalText('sample_text') || 'Request Sample'}
            >
              {props.regionalText('sample_text') || 'Request Sample'}
            </SampleButton>
          </div>
        </div>
      </div>
    </div>
  );
}
